/**
 * ASK — what a join link opens onto (phone). 3056, docs/JOIN-LINKS.md.
 *
 * Twin of `app/src/desktop/screens/Ask.tsx`; the body is shared in
 * `components/AskCard.tsx` so the two trees cannot drift on the copy, which is
 * the part carrying the meaning. Only the frame differs.
 *
 * Bare chrome, like `join` — see the card for why.
 */

import { AskCard } from '../components/AskCard.tsx';
import { QuarterIcon } from '../components/QuarterIcon.tsx';

const M = {
  headFs: '13px',
  bodyFs: '10.5px',
  fieldFs: '12px',
  btnFs: 9,
  pad: '0',
};

export default function Ask(): JSX.Element {
  return (
    <div
      style={{
        minHeight: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: '34px 16px 26px',
        boxSizing: 'border-box',
      }}
    >
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
          <QuarterIcon u={2.5} />
          <div
            style={{
              fontFamily: 'var(--gt-font-pixel)',
              fontSize: '17px',
              color: 'var(--gt-text)',
              lineHeight: 1.6,
              marginTop: '16px',
            }}
          >
            GAMES TONIGHT<span style={{ color: 'var(--acc2)' }}>?</span>
          </div>
        </div>

        <div style={{ marginTop: '26px' }}>
          <AskCard m={M} />
        </div>
    </div>
  );
}
